/* unplugin-vue-components disabled */import { render } from "./sources.vue?vue&type=template&id=023da601&scoped=true"
import script from "./sources.vue?vue&type=script&lang=js"
export * from "./sources.vue?vue&type=script&lang=js"

import "./sources.vue?vue&type=style&index=0&id=023da601&lang=stylus&scoped=true"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-023da601"],['__file',"src/components/sources/sources.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "023da601"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('023da601', __exports__)) {
    api.reload('023da601', __exports__)
  }
  
  module.hot.accept("./sources.vue?vue&type=template&id=023da601&scoped=true", () => {
    api.rerender('023da601', render)
  })

}


export default __exports__